import { render, staticRenderFns } from "./KeywordWarning.vue?vue&type=template&id=3700c293&"
import script from "./KeywordWarning.vue?vue&type=script&lang=js&"
export * from "./KeywordWarning.vue?vue&type=script&lang=js&"
import style0 from "./KeywordWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports